import ResetPassword from './reset-password'
import Verify from './verify'

export default {
    ...ResetPassword,
    ...Verify,
    
    checkAuth({commit}){
        let url = `/auth/user`,
            token = window.localStorage.getItem('tK');
        return new Promise((resolve, reject)=>{
            if (token){
                const headers = {
                    'Authorization': 'Bearer ' + token
                };
                window.axios.post(url, {}, {headers}).then(response=>{
                    const user = response.data.user;
                    commit('SET_USER', user);

                    if (user.my_courses){
                        commit('SET_MY_COURSES', {data: user.my_courses});
                    }
                    if (user.my_packages){
                        commit('SET_MY_PACKAGES', {data: user.my_packages});
                    }
                    // set auth header on axios
                    window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
                    resolve();

                }).catch(error=>{
                    reject(error);
                });
            }else{
                // no token, exit here... unauthenticaterd
                reject();
            }
        })
    },
    registerAction({commit}, payload){
        let url = `/register`;
        return new Promise((resolve, reject)=>{
            window.axios.post(url, payload).then(response=>{
                let token = response.data.token;
                if (token){
                    
                    window.localStorage.setItem('tK', token);
                    window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

                    commit('SET_USER', response.data.user);
                    let redirectToVerify = response.data.verification === 'SENT';
                    resolve({redirect: redirectToVerify ? 'confirm' : 'home', message: response.data.message});
                }else{
                    resolve({redirect: 'login', message: response.data.message});
                }
            }).catch(error=>{
                reject(error);
            })
        });
    },
    loginAction({commit}, payload){
        let url = `/login`;
        return new Promise((resolve, reject)=>{
            
            window.axios.post(url, payload).then(response=>{
                let token = response.data.token;
                
                if (token){        
                    window.localStorage.setItem('tK', token);
                    window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

                    commit('SET_USER', response.data.user);
                    if (response.data.user.my_courses){
                        commit('SET_MY_COURSES', {data: response.data.user.my_courses});
                    }
                    if (response.data.user.my_packages){
                        commit('SET_MY_PACKAGES', {data: response.data.user.my_packages});
                    }
                    resolve();
                }else{
                    reject({});
                }
            }).catch(error=>{
                reject(error);
            })
        });
    },
    logout({commit}){
        window.localStorage.removeItem('tK');
        commit('SET_USER', null);
    }
}